<template>
  <div class="bg-light">
    <div class="words d-flex flex-column">
      <h2 class="important">Denver Office</h2>
      <div class="person">
        <p class="important">Phone</p>
        <p>720-402-3081</p>
        <p class="important">Address</p>
        <p>1001 17th Street, Suite 1050 <br> Denver, CO 80202</p>
        <br>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Contact',
  data() {
    return {

    };
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.words{
  padding-top: 1rem;
}
</style>



// WEBPACK FOOTER //
// src/components/Contact.vue